<!--
 * @Description: 名师团队 -- pc端
 * @Author: xiuwen
 * @Date: 2024-12-26 09:37:05
 * @LastEditors: xiuwen
 * @LastEditTime: 2025-06-25 15:49:14
-->
<template>
	<main class="pc-index pc-center-1280">
		<ClientOnly>
			<n-tabs
				type="line"
				v-if="showTab"
				animated
				@update:value="onUpdate"
				@before-leave="handleBeforeLeave"
				role="tablist"
				aria-label="名師團隊選擇"
			>
				<n-tab-pane
					v-for="item in data"
					:key="item.id"
					:name="item.id"
					:tab="item.teacher_info.nickname"
				>
					<n-spin :show="loading">
						<TeacherInfo
							:data="item"
							:teacherInfo="item.teacher_info"
							:cs-data="csData"
							:key="currentTeacherId"
							:cs-event="item.csEvent"
							:schannel="currentTeacher.schannel"
						/>
						<TeacherService
							:data="teacherService"
							:teacher-id="item.id"
							:teacherInfo="item.teacher_info"
							:chat-event="item.chatEvent"
						/>
						<TeacherSquare :data="teacherSquare" />
						<ActivityContent
							:key="currentTeacherId"
							:data="activityData"
							v-if="activityData.length > 0"
						/>
						<TeacherMedia :data="mediaData" />
					</n-spin>
				</n-tab-pane>
			</n-tabs>
			<template #fallback>
				<div class="loading-tabs">載入中...</div>
			</template>
		</ClientOnly>
		<section class="pc-more-teacher">
			<h2 class="title">更多老師推薦</h2>
			<div class="rank">
				<TeacherRank :data="dongfangRank" :type="'dongfang'" />
				<TeacherRank :data="tarotRank" :type="'tarot'" />
			</div>
		</section>
	</main>
</template>

<script setup>
import {
	getRankingList,
	getResourse,
	getTeacherService,
	getTeacherSquare,
	getUserDetail,
} from "~/api/api";
import { logEvent } from "~/utils/firebase";
import { computed, ref, watchEffect } from "vue";

// naive-ui 组件

// 组件
import { removeDomain } from "~/utils/common";
import ActivityContent from "./components/activity-content/index.vue";
import TeacherInfo from "./components/teacher-info/index.vue";
import TeacherMedia from "./components/teacher-media/index.vue";
import TeacherRank from "./components/teacher-rank/index.vue";
import TeacherService from "./components/teacher-service/index.vue";
import TeacherSquare from "./components/teacher-square/index.vue";

// 图片
import csBg1 from "./images/cs_bg1.png";
import csBg2 from "./images/cs_bg2.png";
import csBg3 from "./images/cs_bg3.png";
import csBg4 from "./images/cs_bg4.png";
import teacher1 from "./images/teacher1.png";
import teacher2 from "./images/teacher2.png";
import teacher3 from "./images/teacher3.png";
import teacher4 from "./images/teacher4.png";

// 客户端环境执行
if (import.meta.client) {
	logEvent("site_master_uv");
}

const data = ref([
	{
		// 振鸿
		id: "164197918000000150",
		bg: teacher4,
		cs_bg: csBg4,
		csClass: 110,
		activityClass: 111,
		mediaClass: 112,
		teacher_info: {},
		tabEvent: "site_master_zhenhong_click",
		csEvent: "site_master_zhenhong_reccalc_click",
		chatEvent: "site_master_zhenhong_ask_click",
		schannel: "master-zhenhong-pc",
	},
	{
		// 烽燧
		id: "64435",
		bg: teacher2,
		cs_bg: csBg2,
		csClass: 113,
		activityClass: 114,
		mediaClass: 115,
		teacher_info: {},
		tabEvent: "site_master_fengsui_click",
		csEvent: "site_master_fengsui_reccalc_click",
		chatEvent: "site_master_fengsui_ask_click",
		schannel: "master-dashixiong-pc",
	},
	{
		// 法名
		id: "162156213800000090",
		bg: teacher3,
		cs_bg: csBg3,
		csClass: 107,
		activityClass: 108,
		mediaClass: 109,
		teacher_info: {},
		tabEvent: "site_master_faming_click",
		csEvent: "site_master_faming_reccalc_click",
		chatEvent: "site_master_faming_ask_click",
		schannel: "master-faming-pc",
	},
	{
		// 慕云
		id: "157425565300200060",
		bg: teacher1,
		cs_bg: csBg1,
		csClass: 104,
		activityClass: 105,
		mediaClass: 106,
		teacher_info: {},
		tabEvent: "site_master_muyun_click",
		csEvent: "site_master_muyun_reccalc_click",
		chatEvent: "site_master_muyun_ask_click",
		schannel: "master-muyun-pc",
	},
	// {
	//   // 麦玲玲
	//   id: '7963',
	//   bg: teacher5,
	//   cs_bg: csBg5,
	//   csClass: 104,
	//   activityClass: 105,
	//   mediaClass: 106,
	//   teacher_info: {},
	// },
]);

const promises = data.value.map(item => {
	return new Promise(async resolve => {
		await getUserDetail({
			uid: item.id,
		}).then(res => {
			item.teacher_info = res.data;
		});
		resolve();
	});
});

const showTab = ref(false);
Promise.all(promises).then(() => {
	showTab.value = true;
});

const currentTeacher = computed(() => {
	const res = data.value.find(item => currentTeacherId.value === item.id);
	logEvent(res.tabEvent);
	return res;
});
const currentTeacherId = ref(data.value[0].id);
const loading = ref(false);
const csData = ref([]);
const activityData = ref([]);
const mediaData = ref([]);
const teacherService = ref([]);
const teacherSquare = ref({
	text: [],
	video: [],
});
const getTeacherData = () => {
	loading.value = true;
	// 获取代言测试
	getResourse({
		class: currentTeacher.value.csClass,
	}).then(res => {
		csData.value = res.data.map(v => {
			return {
				...v,
				jump_url: removeDomain(v.actioncontent.global_type),
			};
		});
		loading.value = false;
	});
	// 获取活动
	getResourse({
		class: currentTeacher.value.activityClass,
	}).then(res => {
		activityData.value = res.data.map(v => {
			return {
				...v,
				jump_url: removeDomain(v.actioncontent.global_type),
			};
		});
	});
	// 获取媒体
	getResourse({
		class: currentTeacher.value.mediaClass,
	}).then(res => {
		mediaData.value = res.data.map(v => {
			return {
				...v,
				jump_url: v.actioncontent.global_type,
			};
		});
	});
	// 获取老师服务
	getTeacherService({
		uid: currentTeacherId.value,
		high_service_type: 1,
	}).then(res => {
		teacherService.value = res.data[0].list;
	});
	// 获取老师廣場
	// getTeacherSquare({
	//   teacher_uid: currentTeacherId.value,
	//   type: 2,
	// }).then((res) => {
	//   teacherSquare.value.text = res.data.list.map((item) => {
	//     return {
	//       ...item,
	//       media_url: JSON.parse(item.media_url),
	//     };
	//   });
	// });
	getTeacherSquare({
		teacher_uid: currentTeacherId.value,
		type: 1,
	}).then(res => {
		teacherSquare.value.video = res.data.list.map(item => {
			return {
				...item,
				media_url: JSON.parse(item.media_url),
			};
		});
	});
};
getTeacherData();

const handleBeforeLeave = () => {
	return !loading.value;
};

const onUpdate = val => {
	csData.value = [];
	currentTeacherId.value = val;
	getTeacherData();
};

const dongfangRank = ref([]);
const tarotRank = ref([]);
getRankingList().then(res => {
	dongfangRank.value = res.data[0].data;
	tarotRank.value = res.data[1].data;
});
</script>

<style lang="scss" scoped>
.pc-index {
	margin-bottom: 80px;
}

.loading-tabs {
	text-align: center;
	padding: 60px;
	color: #666;
	font-size: 16px;
	min-height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
}

:deep(.n-tabs) {
	.n-tabs-nav {
		padding: 0 87px;
		width: 1280px;
		height: 50px;
		font-family:
			PingFang SC,
			PingFang SC;
		background: #b9703a;

		.v-x-scroll {
			height: 100%;
		}

		.n-tabs-tab-wrapper {
			.n-tabs-tab-pad {
				margin: 0 20px;
				align-self: center;
				width: 1px;
				height: 7px;
				border-right: 1.5px solid #ffffff;
				opacity: 0.6;
			}
		}

		.n-tabs-tab {
			.n-tabs-tab__label {
				font-weight: 400;
				font-size: 18px;
				color: #ffffff;
			}
		}

		.n-tabs-tab--active {
			.n-tabs-tab__label {
				font-weight: 600;
			}
		}

		.n-tabs-bar {
			background-color: #ffffff;
		}

		.n-tabs-nav-scroll-content {
			border-bottom: none !important;
		}
	}

	.n-tab-pane {
		padding: 0;
	}
}

:deep(.n-spin) {
	color: #b9703a;
}

.pc-more-teacher {
	margin-top: 40px;
	padding: 0 63px;

	.title {
		margin: 12px 20px 0;
		font-weight: 600;
		font-size: 32px;
		color: #1f2329;
		font-family: PingFang SC;
	}

	.rank {
		margin-top: 24px;
		display: flex;
		justify-content: center;

		& > section {
			margin-right: 10px;

			&:last-child {
				margin-right: 0;
			}
		}
	}
}
</style>
